import MarkDown from './MarkDown';

function App() {
  return (
    <div className='App'>
      <MarkDown />
    </div>
  );
}

export default App;
